import { Injectable } from '@angular/core';

export type LoaderKind = 'off' | 'bar' | 'block';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private blockCount = 0;
  private barCount = 0;

  begin(kind: LoaderKind): void {
    if (kind === 'block') {
      this.blockCount++;
    } else if (kind === 'bar') {
      this.barCount++;
    }
  }

  end(kind: LoaderKind): void {
    if (kind === 'block') {
      this.blockCount = Math.max(0, this.blockCount - 1);
    } else if (kind === 'bar') {
      this.barCount = Math.max(0, this.barCount - 1);
    }
  }

  getMode(): LoaderKind {
    if (this.blockCount > 0) return 'block';
    if (this.barCount > 0) return 'bar';
    return 'off';
  }

  setLoading(loading: boolean) {
    this.blockCount = loading ? 1 : 0;
    if (!loading) {
      this.barCount = 0;
    }
  }

  getLoading(): boolean {
    return this.getMode() !== 'off';
  }
}
